import { JsonPipe } from '@angular/common';
import { Component, OnInit, inject } from '@angular/core';
import { FilterArrayPipe } from '@lbca-shared/pipes/filter-array';
import { DepositsService } from '../components/_old_components/deposits-panel/deposits-panel.service';
import { USER_SERVICE, UserServiceInterface } from '../services/user.services';

@Component({
  selector: 'lib-lbca-legacy',
  imports: [FilterArrayPipe, JsonPipe],
  template: `
    <p>lbca-legacy works!</p>
    {{ [{ name: 'apple' }, { name: 'banana' }] | filterArray : 'app' : 'name' | json }}
  `,
  providers: [DepositsService],
  styles: ``,
})
export class LbcaLegacy implements OnInit {
  readonly userService = inject<UserServiceInterface>(USER_SERVICE);
  readonly depositsService = inject(DepositsService);

  ngOnInit(): void {
    const capability = this.userService.hasCapability('management/deadline');
    console.log('hasCapabilityOnLegacy', capability);
    this.depositsService.getByProcessId({ id: 123 }).subscribe({
      next: (res) => console.log('lbcaLegacy - sucess - depositsService.getByProcessId', res),
      error: (err) => console.error('lbcaLegacy - error - depositsService.getByProcessId', err),
    });
  }
}
